module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1042-cc14a48fa0ba11c237eb799a7d944a44.png";